/**
 * Значения по умолчанию для темы
 */
const defaultOptions = {}

module.exports = defaultOptions
